import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Selection, Text } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { Functions } from 'utils';

import { API } from 'services';

class ModalLinkDevice extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      sensors: [],
      fetching: false,
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit,
          active: false
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  componentDidMount() {

    //Request fetch
    this.setState({
      sensors: [],
      fetching: true
    });
  }

  componentDidUpdate(prevProps, prevState) {

    if (!prevState.fetching && this.state.fetching) {

      //Load available sensors
      API.get('/sensors', { filter: 'available' })
        .then((response) => {

          this.setState({
            sensors: response.data
          });
        })
        .finally(() => {
          this.setState({
            fetching: false
          });
        });

    }
  }

  handleChange(event) {
    this.setState({
      actions: {
        ...this.state.actions,
        submit: {
          ...this.state.actions.submit,
          active: true
        }
      }
    });
  }

  handleSubmit(data, onSucess, onError) {

    API.put(`/devices/${this.props.device.id}/sensors/${data.sensor}`)
      .then((response) => {
        this.props.onClose(data.sensor);
      })
      .catch((error) => {
        onError({ 'sensor': [error.response.data.message] });
      });
  }

  render() {

    let availableSensors = this.state.sensors.map((sensor) => {
      return {
        key: sensor.mac_address,
        text: Functions.formatMacAddress(sensor.mac_address),
        value: sensor.mac_address
      };
    });

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size="small">
          <Header icon="add" content="Associer un capteur" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Name */}
              <Form.Field>
                <label htmlFor="inputSensor">Capteur</label>
                <Selection
                  placeholder={this.state.fetching ? 'Chargement' : null}
                  loading={this.state.fetching}
                  id="inputSensor"
                  name="sensor"
                  options={availableSensors}
                  noResultsMessage="Aucune capteur n'est disponible"
                  onChange={this.handleChange}
                />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalLinkDevice.propTypes = {
  onClose: PropTypes.func.isRequired,
  sensor: PropTypes.shape({
    id: PropTypes.number.isRequired
  })
};

export default ModalLinkDevice;
